// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconSymbolsCheckmark_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s8IconSvg = html `<svg viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M3.00006 4.60932L6.46973 1.13965L7.53039 2.20031L3.00006 6.73064L0.469727 4.20031L1.53039 3.13965L3.00006 4.60932Z" class="svg-bg"/>
</svg>
`;
const _s12IconSvg = html `<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M4.70711 7.17864L10 1.88574L11.4142 3.29996L4.70711 10.0071L1 6.29996L2.41421 4.88574L4.70711 7.17864Z" class="svg-bg"/>
</svg>
`;
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M6.00008 10.8788L14.293 2.58594L15.7072 4.00015L6.00008 13.7073L0.292969 8.00015L1.70718 6.58594L6.00008 10.8788Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.99985 16.3485L21.116 4.23242L22.8837 6.00019L8.99985 19.8841L1.11597 12.0002L2.88373 10.2324L8.99985 16.3485Z" class="svg-bg"/>
</svg>
`;
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M11.0001 21.8182L27.9395 4.87891L30.0608 7.00023L11.0001 26.0609L1.93945 17.0002L4.06077 14.8789L11.0001 21.8182Z" class="svg-bg"/>
</svg>
`;
/**
 * IconSymbolsCheckmark is a generated icon component.
 */
let IconSymbolsCheckmark = IconSymbolsCheckmark_1 = class IconSymbolsCheckmark extends IconBaseElement {
    render() {
        return html `${IconSymbolsCheckmark_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconSymbolsCheckmark.icons = new Map([
    ['s8', _s8IconSvg],
    ['s12', _s12IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconSymbolsCheckmark = IconSymbolsCheckmark_1 = __decorate([
    customElement('zui-icon-symbols-checkmark')
], IconSymbolsCheckmark);
export { IconSymbolsCheckmark };
